(function () {
	'use strict';

	angular
	.module('core')
	.controller('journeyCtrl', journeyCtrl);

	journeyCtrl.$inject = ['$http', '$scope', '$rootScope', '$q', '$timeout', '$route', 'Upload'];

	function checkString(needle, haystack){
		var _return = false;

		if(typeof needle == 'string'){
			_return = haystack.indexOf(needle) >= 0;
		}
		else {
			$(needle).each(function(){
				if(haystack.indexOf(this) >= 0){
					_return = true;
				}
			})
		}

		return _return
	}

	function shadeColor(color, percent) {   
	    var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
	    return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
	}

	function dummyData(){
		var _length = 20;
		var _data = [];

		for(var i=0; i<_length; i++){
			_data.push([i, randFloat(20,100)]);
		}
		return _data;
	}

	function journeyCtrl($http, $scope, $root, $q, $timeout, $route, $upload) {
		var vm = $scope;
		vm.selectedPerson;
		vm.countries = [];
		vm._all = 'All';
		vm._any = 'Any';
		$root.searchTerms = '';
		$root.countryAll = true;

		vm.current = $route.current.params.type;

		vm.chartApi = {};
		vm.chartData = [{
			values: dummyData(),
			area: true
		}];

		vm.lightenColor = function(_color){
			return shadeColor(_color, .85);
		}

		vm.$watch(function(){
			var text = "";
			if (window.getSelection) {
				text = window.getSelection().toString();
			} else if (document.selection && document.selection.type != "Control") {
				text = document.selection.createRange().text;
			}
		    return text;
		}, function(newVal){
			$root.selectedText = newVal;
		})

		vm.recurseEnd = function(index){
			var _recursive = false;
			if(vm.journey != undefined && vm.journey.paths[index] != undefined){
				var _name = vm.journey.paths[index].name.toLowerCase();

				angular.forEach(vm.journey.paths, function(_journey, _index){
					if(_journey.recurseTo != undefined && _journey.recurseTo.toLowerCase() == _name){
						_recursive = _index - index;
					}
				});
			}
			return _recursive;
		}

		vm.chartOptions = {
			'chart':{
				type: 'lineChart',
				margin : {
					top: 0,
					right: 0,
					bottom: 0,
					left: 0
				},
				x: function(d){ return d[0]; },
				y: function(d){ return d[1]/100; },
				average: function(d) { return d.mean/100; },
				interpolate: 'basis',
				showLegend: false,
				showYAxis: false,
				showXAxis: false,
				showValues: false,
				interactive: false,
				yDomain: [0,1],
				duration: 1000,
				useInteractiveGuideline: false,
				tooltip:{
					enabled: false
				},
				clipVoronoi: false,
				showControls: false,
				color: ['#dcecf6']
			}
		}

		vm.chartReady = function(scope, elem){
			//vm.chartApi = scope.api;
		}

		$root.lastUpdated = function(){
			var difference = parseInt((new Date()).getTime()/1000) - vm.updated;
			var time = Math.ceil(difference/60);
			return time;
		}

		vm.anyExports = function(){
			var _return = false;

			angular.forEach(vm.groups, function(group){
				if(group.topics != undefined){
					angular.forEach(group.topics, function(topic){
						if(topic.checked){
							_return = true;
						}
					});
				}
			});

			return _return;
		}

		vm.getTotal = function(_type){
			var _personal = [];
			var _doc = [];
			var _pallet = [];

			angular.forEach(vm.getUsers(), function(user){
				if(user.group != undefined && vm.count(user.Topics) >= (vm.count(user.group.topics) - 1)) {
					if(user.group.name == 'DHL Pallet/Cargo/Freight Rate Quote Group'){
						_pallet.push(user);
					}
					else if(user.group.name == 'DHL Document/Package Rate Quote Group') {
						_doc.push(user);
					}
					else if(user.group.name == 'DHL Personal Rate Quote Group') {
						_personal.push(user);
					}
				}
			});

			switch(_type){
				case 'personal':
				return _personal.length
				break;

				case 'doc':
				return _doc.length
				break;

				case 'pallet':
				return _pallet.length
				break;
			}

			return 0;
		}

		vm.getUsers = function(){
			var _users = [];
			var _country;
			if(arguments.length > 0){
				_country = arguments[0];
			}
			angular.forEach(vm.groups, function(group){
				angular.forEach(group.participants, function(user){
					if(_country == undefined || user.country.code == _country.code){
						_users.push(user);
					}
				});
			});
			return _users;
		}

		vm.personalFilter = function(user){
			var _return = false;
			if(vm.count(user.Topics) >= (vm.count(user.group.topics) - 1) && user.group != undefined && user.group.name == 'DHL Personal Rate Quote Group') {
				_return = true;
			}

			return _return;
		}
		vm.docFilter = function(user){
			var _return = false;
			if(vm.count(user.Topics) >= (vm.count(user.group.topics) - 1) && user.group != undefined && user.group.name == 'DHL Document/Package Rate Quote Group') {
				_return = true;
			}

			return _return;
		}
		vm.palletFilter = function(user){
			var _return = false;
			if(vm.count(user.Topics) >= (vm.count(user.group.topics) - 1) && user.group != undefined && user.group.name == 'DHL Pallet/Cargo/Freight Rate Quote Group') {
				_return = true;
			}

			return _return;
		}

		vm.countryTotal = function(_country){
			var _personal = [];
			var _doc = [];
			var _pallet = [];

			angular.forEach(vm.getUsers(_country), function(user){
				if(user.group != undefined && vm.count(user.Topics) >= (vm.count(user.group.topics) - 1)) {
					if(user.group.name == 'DHL Pallet/Cargo/Freight Rate Quote Group'){
						_pallet.push(user);
					}
					else if(user.group.name == 'DHL Document/Package Rate Quote Group') {
						_doc.push(user);
					}
					else if(user.group.name == 'DHL Personal Rate Quote Group') {
						_personal.push(user);
					}
				}
			});
			return {
				'personal': _personal.length,
				'doc': _doc.length,
				'pallet': _pallet.length,
				'total': _personal.length + _doc.length + _pallet.length
			}
		}

		vm.setFilters = function(_values){
			var _keys = Object.keys(_values);
			angular.forEach(vm.filters, function(filter){
				if(_keys.exists(filter.slug)) {
					angular.forEach(filter.items, function(item){
						if(_values[filter.slug].exists(item.value) || _values[filter.slug].exists(item.name)){
							item.checked = true;
						}
						else {
							item.checked = false;
						}
					})
				}
			});
			$timeout(function(){
				$root.screen = "participants";
			}, 250);
		}

		vm.filters = {
			'groups':{
				'slug':'groups',
				'title':'Groups',
				'items':[]
			},
			'countries':{
				'slug':'countries',
				'title':'Countries',
				'items':[]
			},
			'topics':{
				'slug':'topics',
				'title':'Topics',
				'items':[
					{
						'value':'0',
						'name':'No topics answered',
						'check':function(user){
							return user.Topics == undefined || vm.count(user.Topics) == 0;
						}
					},{
						'value':'some',
						'name':'Some topics answered',
						'check':function(user){
							return (vm.count(user.Topics) < (vm.count(user.group.topics) - 1) && vm.count(user.Topics) > 0);
						}
					},{
						'value':'all',
						'name':'All topics answered',
						'check':function(user){
							return vm.count(user.Topics) >= (vm.count(user.group.topics) - 1);
						}
					}
				]
			},
			'followups':{
				'slug':'followups',
				'title':'Followups',
				'items':[
					{
						'value':'0',
						'name':'No followups answered',
						'check':function(user){
							return user.followUps.questions != 0 && user.followUps.replies == 0;
						}
					},{
						'value':'some',
						'name':'Some followups answered',
						'check':function(user){
							return user.followUps.questions != 0 && user.followUps.replies != 0 && user.followUps.replies < user.followUps.questions;
						}
					},{
						'value':'all',
						'name':'All followups answered',
						'check':function(user){
							return user.followUps.questions != 0 && user.followUps.replies >= user.followUps.questions;
						}
					},{
						'value':'no',
						'name':'No followups asked',
						'check':function(user){
							return user.followUps.questions == 0 || user.followUps.questions == undefined;
						}
					}
				]
			},
			'incentives':{
				'slug':'incentives',
				'title':'Incentive',
				'items':[
					{
						'value':'delivered',
						'name':'Email Delivered',
						'check':function(user){
							return user.incentive != undefined && user.incentive.status == 'Email Delivered';
						}
					},{
						'value':'opened',
						'name':'Email Opened',
						'check':function(user){
							return user.incentive != undefined && user.incentive.status == 'Email Opened';
						}
					},{
						'value':'claimed',
						'name':'Gift Claimed',
						'check':function(user){
							return user.incentive != undefined && user.incentive.status == 'Gift Claimed';
						}
					},{
						'value':'none',
						'name':'No incentive',
						'check':function(user){
							return user.incentive == undefined;
						}
					}
				]
			},
			'sources':{
				'slug':'sources',
				'title':'Source',
				'items':[
					{
						'value':'quote',
						'name':'Get Quote',
						'check':function(user){
							return user.source == 'getquote';
						}
					},{
						'value':'contact',
						'name':'Contact Us',
						'check':function(user){
							return user.source == 'contactus';
						}
					},{
						'value':'respondent',
						'name':'Respondent.io',
						'check':function(user){
							return user.source == 'respondent.io';
						}
					},{
						'value':'unknown',
						'name':'Unknown',
						'check':function(user){
							return user.source == undefined || user.source == '';
						}
					}
				]
			},
			'dates':{
				'slug':'dates',
				'title':'Completed',
				'items':[
					{
						'value':'week',
						'name':'Over a week',
						'check':function(user){
							var _time = (new Date()).getTimezoneOffset() + parseInt((new Date()).getTime()/1000);
							return user.LastUpdated.timestamp < (_time - (60*60*24*7));
						}
					},{
						'value':'threeToSeven',
						'name':'3 to 7 days',
						'check':function(user){
							var _time = (new Date()).getTimezoneOffset() + parseInt((new Date()).getTime()/1000);
							return user.LastUpdated.timestamp >= (_time - (60*60*24*7)) && user.LastUpdated.timestamp < (_time - (60*60*24*3));
						}
					},{
						'value':'threeFewer',
						'name':'3 or fewer days',
						'check':function(user){
							var _time = (new Date()).getTimezoneOffset() + parseInt((new Date()).getTime()/1000);
							return user.LastUpdated.timestamp >= (_time - (60*60*24*3));
						}
					}
				]
			},
			'service':{
				'slug':'service',
				'title':'Service',
				'items':[]
			}
		}

		vm.anyFilters = function(){
			var _anyFilter = false;
			angular.forEach(vm.filters, function(filter){
				angular.forEach(filter.items, function(item){
					if(item.checked == true){
						_anyFilter = true;
					}
				});
			});

			return _anyFilter;
		}
		vm.clearFilters = function(){
			angular.forEach(vm.filters, function(filter){
				angular.forEach(filter.items, function(item){
					item.checked = false;
				});
			});
		}

		vm.getChecked = function(_objects, _val, _default, _all){
			var _return = [];

			angular.forEach(_objects, function(_object){
				if(_object.checked == true){
					_return.push(_object);
				}
			});

			return _return;
		}

		vm.addFilter = function(){
			$root.modal = true;
			vm.showFilters = true;
		}

		vm.toggleChecked = function(_array){
			if(vm.getChecked(_array).length == 0){
				vm.checkAll(_array);
			}
			else {
				vm.uncheckAll(_array);
			}
		}

		vm.toggleAll = function(_array){
			$timeout(function(){
				angular.forEach(_array, function(_item){
					_item.checked = _item.checked != undefined ? !_item.checked : true;
				});
			});
		}

		vm.checkAll = function(_array){
			$timeout(function(){
				angular.forEach(_array, function(_item){
					_item.checked = true;
				});
			});
		}
		vm.uncheckAll = function(_array){
			$timeout(function(){
				angular.forEach(_array, function(_item){
					_item.checked = false;
				});
			});
		}

		vm.select = function(_person){
			if(_person.Topics != undefined){
				_person.tab = 'focusgroup';
			}
			else if(_person['Survey Gizmo'] != undefined){
				_person.tab = 'gizmo';
			}
			else if(_person['Respondent.io'] != undefined){
				_person.tab = 'respondent';
			}
			else if(_person.details != undefined){
				_person.tab = 'details';
			}
			vm.selectedPerson = _person;
			$root.modal = true;
		}
		vm.deselect = function(){
			$root.modal = false;
			$timeout(function(){
				vm.selectedPerson = null;
			}, 500);
		}

		vm.count = function(_obj){
			var _count = 0;
			if(_obj != undefined){
				_count = Object.keys(_obj).length;
			}
			return _count;
		}

		vm.hasReplies = function(topic){
			var _return = false;

			if(topic.Reply != undefined && topic.Reply != ''){
				_return = true;
			}

			return _return;
		}

		vm.hideFilters = function(except){
			angular.forEach(vm.filters, function(filter){
				if(!angular.equals(filter, except)){
					filter.show = false;
				}
			});
		}

		vm.userFilters = function(user){
			var _return = true;
			var _tmp = {};

			angular.forEach(vm.filters, function(filter){
				var _any = false;
				_tmp[filter.slug] = false;

				angular.forEach(filter.items, function(item){
					if(item.checked == true){
						_any = true;
						if(item.check(user)){
							_tmp[filter.slug] = true;
						}
					}
				});

				if(!_any){
					_tmp[filter.slug] = true;
				}
			});

			if($root.searchTerms != undefined && $root.searchTerms != ''){
				_tmp.search = false;
				var _terms = $root.searchTerms.toLowerCase();

				angular.forEach(user.Topics, function(replies){
					angular.forEach(replies, function(reply){
						if(reply.Reply != undefined && reply.Role == 'participant'){
							var _text = reply.Reply;
							if(typeof _text == 'string' && _text.length > 0){
								_text = _text.toLowerCase();

								if(_text.indexOf(_terms) >= 0){
									_tmp.search = true;
								}
							}
						}
					});
				});
			}

			angular.forEach(_tmp, function(filter){
				if(filter == false){
					_return = false;
				}
			});

			return _return;
		}

		vm.initPerson = function(_person, _group){
			_group = angular.copy(_group);
			delete _group.participants;
			_person.group = _group;
			vm.setFollowUps(_person);
		}

		vm.setFollowUps = function(_person){
			_person.followUps = {
				questions: 0,
				replies: 0
			}
			if(_person['Topics'] != undefined){
				$(Object.keys(_person['Topics'])).each(function(){
					var _key = this;
					if(_key != 'Closing' && _key != 'Welcome'){
						var _topic = _person['Topics'][_key];
						var _questions = [];
						var _replies = [];

						$(_topic).each(function(){
							if(this.Role == 'participant' && this.Level != '1'){
								_replies.push(this);
							}
							else if(this.Role == 'moderator'){
								_questions.push(this);
							}
						});
						_person.followUps.questions = _person.followUps.questions + _questions.length;
						_person.followUps.replies = _person.followUps.replies + (_replies.length < _questions.length ? _replies.length : _questions.length);
					}
				});
			}
		}

		vm.upload = function(_files) {
			var _queue = [];

			if(arguments.length > 1){
				var key = arguments[1];
				$root.stores[key].dragging = false;
			}
			else {
				var key = $root.newStore();
			}
			
			$root.files[key].files = $root.files[key].files.concat(_files);

			var files = $root.files[key].files;

			if (files && files.length) {
				if(key == $root.currentStore && $root.files[key].detailsSeen !== true){
					$root.stores[key] = {
						'files':$root.files[key],
						'uploads':$root.uploads[key],
						'hash':key,
						'started': (new Date()),
						'date':$root.getDate(),
						'status': 'Uploading',
						'storeIndex':$root.indexer++
					}
					$root.showModal('set-details');
					$root.files[key].detailsSeen = true;
				}

				vm.processing = true;
				$(files).each(function(){
					var file = this;
					if (!file.$error && $root.uploads[key][file.name] == undefined) {
						$root.uploads[key][file.name] = {}
						var _data = {
							"file": file
						};
						_data[$('#phpUpload').attr('name')] = file.name.toLowerCase()
						_queue.push($upload.upload({
							url: './services/upload.php',
							data: _data
						}).then(function (resp) {
							$root.uploads[key][file.name].key = file.name;
							$root.uploads[key][file.name].completed = true;
							$root.uploads[key][file.name].data = './tmp/' + resp.data;
							$root.uploads[key][file.name].sets = {}
						}, null, function (evt) {
							$root.uploads[key][file.name] = evt
						}));
					}
				});

				$root.setRandomOrders(key);
				$root.setRandomCustomers(key);
				$root.setRandomMessages(key);

				$q.all(_queue).then(function(){
					vm.processing = false;

					$http.post('./services/organize.php', Object.keys($root.uploads[key])).then(function(ret){
						$root.stores[key].sets = ret.data.sets;
						$root.stores[key].people = ret.data.people;
						
						$(Object.keys(ret.data.files)).each(function(index){
							$root.uploads[key][this].sets = angular.copy(ret.data.files[this].sets);
							$root.uploads[key][this].people = angular.copy(ret.data.files[this].people);
							$root.uploads[key][this].exif = angular.copy(ret.data.files[this]);
							delete $root.uploads[key][this].exif.sets;
							delete $root.uploads[key][this].exif.people;
						});
					});

					$timeout.cancel($root.files[key].timer);
					$root.files[key].timer = $timeout(function(){
						vm.checkComplete(key);
					}, 1000);
				});
			}
		};

		$root.count = vm.count;

		vm.loadParticipants = function(response){
			vm.updated = response.data.time; 
			vm.groups = response.data.groups;
			angular.forEach(vm.groups, function(group){
				var _group = {
					'name':group.name,
					'value':group.name.toSlug(),
					'check':function(user){
						return user.group.name == group.name;
					}
				}
				if(!vm.filters.groups.items.exists(_group)){
					vm.filters.groups.items.push(_group);
				}

				angular.forEach(group.participants, function(person){
					vm.initPerson(person, group);
					var _country = angular.copy(person.country);
					_country.value = _country.code;
					_country.check = function(user){
						return user.country.code != undefined && user.country.code == _country.code;
					}
					if(!vm.filters.countries.items.exists(_country)){
						vm.filters.countries.items.push(_country);
					}
					if(person.details != undefined && person.details['DHL Service'] != undefined){
						var _name = angular.copy(person.details['DHL Service']);
						var _service = {
							'name':_name,
							'value':_name.toSlug(),
							'check':function(user){
								return user.details != undefined && user.details['DHL Service'] != undefined && user.details['DHL Service'] == _name;
							}
						}
						if(!vm.filters.service.items.exists(_service)){
							vm.filters.service.items.push(_service);
						}
					}
				})
			});
			var _service = {
				'name':'Unknown',
				'value':'unknown',
				'check':function(user){
					return user.details == undefined || user.details['DHL Service'] == undefined;
				}
			}
			if(!vm.filters.service.items.exists(_service)){
				vm.filters.service.items.push(_service);
			}
			$root.loading = false;
		}

		vm.updateData = function(){
			$root.loading = true;
			$http.get('./services/participants.php?t='+(new Date()).getTime()+'&reset', {
				headers: {
					'Content-Type' : 'application/json; charset=UTF-8'
				}
			}).
			then(vm.loadParticipants);
		}

		vm.$watch('current', function(newVal){
			if(newVal != undefined){
				$http.get('./data/'+newVal+'.json?t='+(new Date()).getTime()).
				then(function(response){
					$root.loading = false;
					vm.journey = response.data;
					var _data = [[0,50]];
					var _most = 0;
					var _count = 1;
					var _last = 0;

					angular.forEach(vm.journey.paths, function(path, index){
						_data.push([_count, path.feeling.level]);
						_count = _count + 2;
						_last = path.feeling.level;
					});
					_data.push([_count - 1, _last*.8]);
					vm.chartData = [{
						"values":_data,
						"area": true
					}];
				});
			}
		})

		vm.init = function() {
			
		}
		vm.init();
	}
})();